import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
	selector: "app-device-details-modal",
	templateUrl: "./device-details-modal.component.html",
	styleUrls: ["./device-details-modal.component.scss"],
})
export class DeviceDetailsModalComponent {
	deviceData: any;
	constructor(
		private params: ActivatedRoute,
		private router: Router,
		private dialogRef: MatDialogRef<DeviceDetailsModalComponent>,
		@Inject(MAT_DIALOG_DATA) data: {data: any}
	) {
		if(data != null){
			this.deviceData = data.data;
		}
	}

	viewDetails() {
		this.closeModal();
		this.router.navigate([`/Device/${this.deviceData.ID}?cdr=false&deviceid=${this.deviceData.CDRDeviceID}`]);
	}

	async closeModal() {
		this.dialogRef.close()
	}
}
